import React from 'react'
import Video from '../components/Video'
import MediaRender from '../components/general/MediaRender'

const Media = ({ options }) => {
    switch (options.type) {
    case 'video':
        return (
            <Video
                videoSrcURL={options.videoSrcURL}
                videoTitle={options.videoTitle}
                height={options.videoHeight || '656px'}
            />
        )
        break
    default: // image or youtube video
        return (
            <MediaRender file={options.media.set && options.media.set[0]} alt={options.caption || ''} options={{
                backgroundVideo: true, backgroundImage: true, overlay: true, autoplay: options.autoplay && options.autoplay==='true'? true : false }} />
        )
    }
}

export default Media
